module.exports = __webpack_public_path__ + "static/media/laptop-code.c5c18220.svg";